import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { CredentialsService } from '@app/core';
import { ROLES } from '@app/constants';
import { UtilService } from '@app/shared/services/util.service';

/**
 * Permite el acceso solo a usuarios con rol Administrator.
 * El resto se redirige a `fallback`.
 */
function denyUnlessAdministrator(
    state: RouterStateSnapshot,
    fallback: string
): true | UrlTree {
    const credentialsService = inject(CredentialsService);
    const utilService = inject(UtilService);
    const router = inject(Router);

    const role =
        credentialsService.credentialsCurrentUser?.role ||
        credentialsService.credentials?.user?.role;

    if (role === ROLES.ADMINISTRATOR) {
        return true;
    }

    utilService.presentToast(
        `No estás autorizado para ingresar a la ruta ${state.url}`,
        'error',
        5000
    );
    return router.parseUrl(fallback);
}

/** Dashboard: usuarios no administradores vuelven a inicio. */
export const administratorGuard: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => denyUnlessAdministrator(state, '/home');

/** CRM admin: usuarios no administradores vuelven al CRM. */
export const AdministratorGuard: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => denyUnlessAdministrator(state, '/external/crm');
